import type {FetchWithHeadersFunction} from '@yandex-delivery/api/repo/types'

const getCleanBS64String = (str: string): string => str.split('base64,')[1]

// Convert file to base64 string
export const convertFileToBase64 = (file: File, {withoutPrefix}: {withoutPrefix?: boolean} = {}): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const readerResult = reader.result as string
      const result = withoutPrefix ? getCleanBS64String(readerResult) : readerResult
      resolve(result)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export const mapBytesToMegaBytes = (bites: number, precision = 2): number =>
  Number((bites / Math.pow(1024, 2)).toFixed(precision))

export const binaryToBlob = (data: string | undefined, errorText: string = 'Empty data'): Blob => {
  if (!data) {
    throw new Error(errorText)
  }

  const buffer = new ArrayBuffer(data.length * 2)
  const bufferView = new Uint16Array(buffer)
  for (let i = 0; i < data.length; i++) {
    bufferView[i] = data.charCodeAt(i)
  }

  return new Blob([bufferView], {
    type: 'data/csv;charset=UTF-16LE;',
  })
}

export const blobToFile =
  (filename: string) =>
  (blob: Blob): void => {
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.rel = 'noopener'
    link.download = filename
    link.href = url
    link.click()

    URL.revokeObjectURL(url)
  }

export const urlToFile = (filename: string, fetch: FetchWithHeadersFunction) => async (url: string) => {
  const response = await fetch({url})
  if (response.body instanceof Blob) {
    blobToFile(filename)(response.body)
  }
}
